import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const switchTextDefaultVariants = {}
const switchTextCompoundVariants = []

const switchTextSlotNames = [
  [
    "root",
    "switch-text__root"
  ],
  [
    "hidden",
    "switch-text__hidden"
  ],
  [
    "visible",
    "switch-text__visible"
  ]
]
const switchTextSlotFns = /* @__PURE__ */ switchTextSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, switchTextDefaultVariants, getSlotCompoundVariant(switchTextCompoundVariants, slotName))])

const switchTextFn = memo((props = {}) => {
  return Object.fromEntries(switchTextSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const switchTextVariantKeys = []
const getVariantProps = (variants) => ({ ...switchTextDefaultVariants, ...compact(variants) })

export const switchText = /* @__PURE__ */ Object.assign(switchTextFn, {
  __recipe__: false,
  __name__: 'switchText',
  raw: (props) => props,
  variantKeys: switchTextVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, switchTextVariantKeys)
  },
  getVariantProps
})